import { controls } from "../controls";

const ms444 = {
  label: "NPA Register Master",
  pageLabel: "NPA Register Master",
  starting: true,
  url: "ms444",
  bulk: { columns: ["account_number", "balance", "odamt", "d1_class", "d2_class", "d3_class", "l_a_class60", "new_od_60", "no_mrg_6"] },
  formActions: { edit: { allow: true }, delete: { allow: true }, audit: { allow: true } },
  pageType: "history",
  // formTabs: {
  //   allTabs: [
  //     {
  //       label: "Basic Info",
  //       uid: "create",
  //       style: { fontFamily: "verdana" }
  //     }
  //   ]
  // },
  filter: [

    ...controls.displayText({tab: "filter",label: "Account Number",width:"col-sm-2"}),
    ...controls.AccountNumber({tab: "filter",forceRender:true,beforeLeave:["createAcNo"]}),
    ...controls.showData({tab: "filter",data: "account_number_display", name: "account_number",width:"col-sm-2"}),
    
     ...controls.displayText({tab: "filter",label: "",width:"col-sm-5 "}),

    ...controls.displayText({tab: "filter",label: "Outstanding as on date", width: "col-sm-2" }),
    ...controls.numberOnly({tab: "filter",name: "balance", width: "col-sm-2", placeHolder: "Outstanding as on date" }),
    
    ...controls.displayText({tab: "filter",label: "Overdue as on date", width: "col-sm-2" }),
    ...controls.numberOnly({tab: "filter",name: "odamt", width: "col-sm-2", placeHolder: "Outstanding as on date" }),
       
    ...controls.displayText({tab: "filter",label: "",width:"col-sm-5 "}),

    ...controls.displayText({tab: "filter",label: "- Classification of Thak Zindagi -",width:"col-sm-2 "}),
    
     ...controls.displayText({tab: "filter",label: "",width:"col-sm-5 "}),

    ...controls.displayText({tab: "filter",label: "Overdues Above 1 year but below 3 years", width: "col-sm-2" }),
    ...controls.numberOnly({tab: "filter",name: "d1_class", width: "col-sm-2", placeHolder: "Overdues Above 1 year but below 3 years" }),

    ...controls.displayText({tab: "filter",label: "Overdues Above 3 year but below 4 years", width: "col-sm-2" }),
    ...controls.numberOnly({tab: "filter",name: "d2_class", width: "col-sm-2", placeHolder: "Overdues Above 3 year but below 4 years" }),

    ...controls.displayText({tab: "filter",label: "Overdues Above 4 year but below 6 years", width: "col-sm-2" }),
    ...controls.numberOnly({tab: "filter",name: "d3_class", width: "col-sm-2", placeHolder: "Overdues Above 4 year but below 6 years" }),

    ...controls.displayText({tab: "filter",label: "Overdues Above 6 years", width: "col-sm-2" }),
    ...controls.numberOnly({tab: "filter",name: "l_a_class60", width: "col-sm-2", placeHolder: "Overdues Above 6 years" }),

    ...controls.displayText({tab: "filter",label: "Overdues Above 6 years (New)", width: "col-sm-2" }),
    ...controls.numberOnly({tab: "filter",name: "new_od_60", width: "col-sm-2", placeHolder: "Overdues Above 6 years (New)" }),

    ...controls.displayText({tab: "filter",label: "Non Mortgage Loan above 6 Year", width: "col-sm-2" }),
    ...controls.numberOnly({tab: "filter",name: "no_mrg_6", width: "col-sm-2", placeHolder: "Non Mortgage Loan above 6 Year" }),

    ...controls.displayText({ tab: "filter", label: "# Records", width: "col-sm-2" }),
    ...controls.perPage({ tab: 'filter' }),
  ],


  form: [
    
    ...controls.displayText({label: "Account Number",width:"col-sm-2"}),
    ...controls.AccountNumber({forceRender:true,beforeLeave:["createAcNo"]}),
    ...controls.showData({data: "account_number", name: "account_number",width:"col-sm-2"}),
    
     ...controls.displayText({tab: "filter",label: "",width:"col-sm-5 "}),

    ...controls.displayText({label: "Outstanding as on date", width: "col-sm-2" }),
    ...controls.numberOnly({name: "balance", width: "col-sm-2", placeHolder: "Outstanding as on date" }),
    
    ...controls.displayText({label: "Overdue as on date", width: "col-sm-2" }),
    ...controls.numberOnly({name: "odamt", width: "col-sm-2", placeHolder: "Outstanding as on date" }),
       
    ...controls.displayText({tab: "filter",label: "",width:"col-sm-5 "}),

    ...controls.displayText({tab: "filter",label: "- Classification of Thak Zindagi -",width:"col-sm-2 "}),
    
     ...controls.displayText({tab: "filter",label: "",width:"col-sm-5 "}),

    ...controls.displayText({label: "Overdues Above 1 year but below 3 years", width: "col-sm-2" }),
    ...controls.numberOnly({name: "d1_class", width: "col-sm-2", placeHolder: "Overdues Above 1 year but below 3 years" }),

    ...controls.displayText({label: "Overdues Above 3 year but below 4 years", width: "col-sm-2" }),
    ...controls.numberOnly({name: "d2_class", width: "col-sm-2", placeHolder: "Overdues Above 3 year but below 4 years" }),

    ...controls.displayText({label: "Overdues Above 4 year but below 6 years", width: "col-sm-2" }),
    ...controls.numberOnly({name: "d3_class", width: "col-sm-2", placeHolder: "Overdues Above 4 year but below 6 years" }),

    ...controls.displayText({label: "Overdues Above 6 years", width: "col-sm-2" }),
    ...controls.numberOnly({name: "l_a_class60", width: "col-sm-2", placeHolder: "Overdues Above 6 years" }),

    ...controls.displayText({label: "Overdues Above 6 years (New)", width: "col-sm-2" }),
    ...controls.numberOnly({name: "new_od_60", width: "col-sm-2", placeHolder: "Overdues Above 6 years (New)" }),

    ...controls.displayText({label: "Non Mortgage Loan above 6 Year", width: "col-sm-2" }),
    ...controls.numberOnly({name: "no_mrg_6", width: "col-sm-2", placeHolder: "Non Mortgage Loan above 6 Year" }),


  ],
  history: {
    perPage: 10,
    reportHeader: "NPA Register Master",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: true,
    displayColumns: [
      {
        Header: "Account Number",
        accessor: "account_number",
        width: 140,
        rwidth: 50
      },
      {
        Header: "Name Of Society",
        accessor: "descn",
        width: 200,
        rwidth: 50
      },
      {
        Header: "Outstanding as on date",
        accessor: "balance",
        type:"currency",
        width: 120
      },
      {
        Header: "Overdue as on date",
        accessor: "odamt",
        type:"currency",
        width: 120
      },
      {
        Header: "Classification of Thak Zindagi",
        columns: [
          {
            Header: "Overdues Above 1 year but below 3 years",
            accessor: "d1_class",
            type:"currency",
            width: 100
          },
          {
            Header: "Overdues Above 3 year but below 4 years",
            accessor: "d2_class",
            type:"currency",
            width: 100  
          },
          {
            Header: "Overdues Above 4 year but below 6 years",
            accessor: "d3_class",
            type:"currency",
            width: 100 
          },
          {
            Header: "Overdues Above 6 years",
            accessor: "l_a_class60",
            type:"currency",
            width: 100  
          },
          {
            Header: "Overdues Above 6 years (New)",
            accessor: "new_od_60",
            type:"currency",
            width: 100  
          },
          {
            Header: "Non Mortgage Loan above 6 Year",
            accessor: "no_mrg_6",
            type:"currency",
            width: 100  
          },
        ]
      },      
      {
        Header: "Total NPA (Outstanding)",
        accessor: "tot_npa",
        type:"currency",
        width: 100,
        rwidth: 35 
      }
    ]
  }
};

export default ms444;